import { SITE_CONFIG } from '../config/site-config';
import { escapeHtml } from '../lib/html';
import { isConfigured } from '../lib/links';
import { icon } from './icons';

/* ---- Platform overview video (hidden until PLATFORM_VIDEO_ID is set) ---- */
export function videoSection(): string {
  const id = SITE_CONFIG.PLATFORM_VIDEO_ID;
  if (!isConfigured(id)) return '';
  return `
  <section class="s tight-top" id="video" aria-labelledby="video-h">
    <div class="wrap narrow-video">
      <h2 id="video-h" class="sr-only">Platform overview video</h2>
      <div class="video rv" data-video="${escapeHtml(id)}">
        <button type="button" class="video-play" aria-label="Play the ReTax360 platform overview video">
          <img src="https://i.ytimg.com/vi/${encodeURIComponent(id)}/hqdefault.jpg" alt="" loading="lazy">
          <span class="vp-btn">${icon('play')}</span><span class="vp-lab">Watch the platform overview</span>
        </button>
      </div>
      <p class="fine" style="margin-top:10px">The video loads from YouTube (privacy-enhanced mode) when you press play.</p>
    </div>
  </section>`;
}
